module.exports = __webpack_public_path__ + "media/assets/icons/double-852b303be9d1995ebca89bedab5e05d4.svg";